import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {User} from 'projects/core/src/lib/login/data/user';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';

@JsonObject('model.time_card.CurrentEntry')
export class CurrentEntry extends AbstractModel {

  @JsonProperty(String, 'startTime')
  startTime?: string;

  @JsonProperty(String, 'finishTime')
  finishTime?: string;

  @JsonProperty(Number, 'userId')
  userId?: number;

  @JsonProperty(String, 'jobName')
  jobName?: string;

  @JsonProperty(String, 'type')
  type?: string;

  @JsonProperty(Number, 'duration')
  duration?: number;


}
